import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteRole, getRolesForApplication, updateRole } from "../../actions";
import { Button, Tooltip, Modal, Typography } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  TeamOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import RoleModal from "./manage-role/RoleModal";
import { errorAction, types as at } from "@authzsvc/api-lib";
import { showErrorNotification } from "../../utils";

const { Text } = Typography;

const RoleRow = ({
  role,
  actions: { updateRole, deleteRole, getRolesForApplication },
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleAssign = () => {
    navigate(`/manage/${role.applicationId}/role/${role.id}`);
  };

  const handleDeleteConfirm = async () => {
    setDeleteModalOpen(false);
    const resp = await deleteRole(role);
    if (resp?.type === errorAction(at.DELETE_ROLE)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    }
  };

  const handleEditSubmit = async (updatedRole) => {
    setEditModalOpen(false);
    await updateRole(updatedRole);
    await getRolesForApplication(role.applicationId);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
        {!role.applyToAllUsers && (
          <Tooltip title="Assign role to groups">
            <Button
              color="green"
              variant="filled"
              icon={<TeamOutlined />}
              onClick={handleAssign}
              id="assignRoleToGroupsButton"
            />
          </Tooltip>
        )}
        <Tooltip title="Edit role details">
          <Button
            id="editRoleDetailsButton"
            color="blue"
            variant="filled"
            onClick={() => setEditModalOpen(true)}
            icon={<EditOutlined />}
          />
        </Tooltip>
        <Tooltip title="Delete role">
          <Button
            icon={<DeleteOutlined />}
            danger
            color="red"
            variant="filled"
            onClick={() => setDeleteModalOpen(true)}
            id="deleteRoleButton"
          />
        </Tooltip>
      </div>

      {/* Edit Role Modal */}
      <RoleModal
        initialValues={role}
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSubmit={handleEditSubmit}
        isEdit={true}
      />

      {/* Delete Role Confirmation Modal */}
      <Modal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        onOk={handleDeleteConfirm}
        okText="Delete Role"
        cancelText="Cancel"
        cancelButtonProps={{
          onClick: () => setDeleteModalOpen(false),
          type: "default",
          color: "gray",
          variant: "filled",
        }}
        okButtonProps={{ danger: true, color: "red", variant: "filled" }}
        keyboard={true}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <ExclamationCircleOutlined
              style={{ fontSize: 24, color: "#faad14" }}
            />
            <Text strong>Delete Role: {role.displayName}?</Text>
          </div>
        }
        width={500}
        centered
        closable
      >
        <Text>
          Are you sure you want to delete this role? This action cannot be
          undone.
        </Text>
      </Modal>
    </>
  );
};

RoleRow.propTypes = {
  role: PropTypes.object,
  actions: PropTypes.shape({
    deleteRole: PropTypes.func,
    updateRole: PropTypes.func,
    getRolesForApplication: PropTypes.func,
  }),
};

export default connect(null, (dispatch) => ({
  actions: bindActionCreators(
    {
      deleteRole,
      getRolesForApplication,
      updateRole,
    },
    dispatch,
  ),
}))(RoleRow);
